import type { JSX } from 'react';
import { Center, Loader, type MantineSize } from '@mantine/core';
import classes from './CenteredLoader.module.css';

export interface ICenteredLoaderProps {
  /** Loader size (Mantine size token). Defaults to `'md'`. */
  size?: MantineSize;
}

/**
 * Full-area centered loading spinner — used as the Suspense fallback for lazy
 * route chunks and for route/section loading states. Uses a `min-height` (not
 * `height: 100%`) so it centers reliably inside min-height-based parents such
 * as `AppShell.Main`, where a percentage height collapses to content height.
 */
function CenteredLoader({ size = 'md' }: Readonly<ICenteredLoaderProps>): JSX.Element {
  return (
    <Center className={classes.root}>
      <Loader size={size} />
    </Center>
  );
}

export default CenteredLoader;
